<template>
  <b-form-group
    :id="formGroupId"
    :label="label"
    :label-for="id"
    label-class="label-bold"
    :invalid-feedback="errorMsg"
    :state="state"
  >
    <p class="form-text text-secondary text-smaller-1 px-3 pb-1 m-0">
      - For pic with <strong>one</strong> dog: If mixed or unknown breed, select
      'Mixed'.
    </p>
    <p class="form-text text-secondary text-smaller-1 px-3 pb-1 m-0">
      - For pic with <strong>more than one</strong> dog: If they are all the
      <strong>same</strong> breed, select that breed. If more than one breed is
      represented in the photo, select 'Mixed' and list their breeds in the
      'Breed Description' field that appears.
    </p>
    <b-form-select
      v-if="breedsLoaded"
      v-model="selectedBreed"
      :options="options"
      :selected="selected"
      @change="showBreed($event)"
      :state="state"
      :disabled="isDisabled"
    ></b-form-select>

    <p v-if="breedsLoaded" class="text-smaller-1 text-center m-2">
      Don't see your dog's breed listed?
      <router-link to="/contact">Let us know here.</router-link>
    </p>

    <ButtonLoadBreeds v-else @on-click="checkBreedsLoaded($event)" />
  </b-form-group>
</template>

<script>
function objEmpty(obj) {
  for (let k in obj) {
    if (hasOwnProperty.call(obj, k)) {
      return false;
    }
  }
  return true;
}

import ButtonLoadBreeds from '@/components/form/FormButtonLoadBreeds';

export default {
  name: 'SelectListBreeds',
  components: {
    ButtonLoadBreeds,
  },
  props: {
    selected: {
      default: '',
    },
    id: {},
    label: {},
    state: {
      default: null,
    },
    errorMsg: {},
    disabled: null,
  },

  data: function () {
    return {
      breedsLoaded: true,
      options: [],
    };
  },
  computed: {
    formGroupId: function () {
      return this.id + '-group';
    },
    isDisabled: function () {
      return this.disabled;
    },
    selectedBreed: {
      get: function () {
        return this.selected;
      },
      set: function (breed) {
        return breed;
      },
    },
  },
  methods: {
    showBreed: function (breedId) {
      // console.log('breedId is', val, 'breed is', this.$store.state.breeds[val]);
      this.$emit('breed-selected', {
        breedId,
        breed: this.$store.state.breeds[breedId],
      });
    },
    // 'Load Breeds' button click handler
    // Param: boolean: true if breeds loaded, false if not
    checkBreedsLoaded: function (breedsDidLoad) {
      this.breedsLoaded = breedsDidLoad;
      if (breedsDidLoad) {
        this.loadSelectList();
      }
    },

    // Load the select list with breeds data.
    loadSelectList: function (breeds = this.$store.state.breeds) {
      var sortedByBreedTuples = Object.keys(breeds)
        .map((breedId) => [breedId, breeds[breedId].breed])
        .sort((a, b) => (a[1] > b[1] ? 1 : -1));

      this.options.push({ value: '', text: 'Select breed...' });
      sortedByBreedTuples.forEach((tuple) => {
        this.options.push({ value: tuple[0], text: tuple[1] });
      });
    },

    // Param: breeds: obj: breedId => breed
    // loadSelectList: function (breeds = this.$store.state.breeds) {
    //   var sortedByBreedTuples = Object.keys(breeds)
    //     .map((breedId) => [breedId, breeds[breedId]])
    //     .sort((a, b) => (a[1] > b[1] ? 1 : -1));

    //   this.options.push({ value: '', text: 'Select breed...' });
    //   sortedByBreedTuples.forEach((tuple) => {
    //     this.options.push({ value: tuple[0], text: tuple[1] });
    //   });
    // },
  },
  async created() {
    var breeds = this.$store.state.breeds; // Returns an object: breedId => breed
    // Breeds prop of state should be populated during login, but if there was a problem there,
    // the 'breeds' prop will still have its default value: an empty obj {}.
    // If so, signal that the breeds data did NOT load.
    // If the breeds obj IS populated, load up the HTML select list with the breeds data.
    if (objEmpty(breeds)) {
      this.breedsLoaded = false;
      return;
    }
    this.loadSelectList(breeds);
  },
};
</script>

<style>
</style>